import { PaginationProps } from 'rc-pagination'
import React from 'react'

import 'rc-pagination/assets/index.css'

import useI18n from '@/common/hooks/useI18n'

import { StyledPagination } from './styled'
import { PREVIOUS, NEXT } from './translation'

const Pagination = (props: PaginationProps) => {
  const { t } = useI18n()

  return (
    <StyledPagination
      {...props}
      prevIcon={t(PREVIOUS)}
      nextIcon={t(NEXT)}
      jumpPrevIcon='...'
      jumpNextIcon='...'
    />
  )
}

export default Pagination
